import React from 'react'
import { InstallType, useIsEligibleForInstall } from '../../../../lib/hooks/install-eligibility'
import { BrowserSpecificExtensionInstallButtonProps } from './browser-specific'
import { EdgeChromiumInstallButton } from './edgeChromium'
import { EdgePreChromiumInstallButton } from './edge-pre-chromium'

export type EdgeInstallButtonProps = BrowserSpecificExtensionInstallButtonProps

export const EdgeInstallButton: React.FC<EdgeInstallButtonProps> = (props) => {
  const isEdgeChromium = useIsEligibleForInstall(InstallType.EdgeChromium)

  if (isEdgeChromium) {
    return <EdgeChromiumInstallButton {...props} />
  }

  return <EdgePreChromiumInstallButton {...props} />
}
